import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=1f8215cd&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=1f8215cd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8215cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8215cd')) {
      api.createRecord('1f8215cd', component.options)
    } else {
      api.reload('1f8215cd', component.options)
    }
    module.hot.accept("./UploadImg.vue?vue&type=template&id=1f8215cd&scoped=true", function () {
      api.rerender('1f8215cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/payPopup/UploadImg.vue"
export default component.exports